export default {"src":"/_next/static/media/iden3.460c2d34.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};